var React = require('react');

function ComponentsIcon (props) {
    return React.createElement("svg",props,[React.createElement("rect",{"width":"75","height":"75","fill":"white","key":0}),React.createElement("rect",{"width":"75","height":"75","rx":"12","fill":"#E8F1FB","key":1}),React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M62.5 31.25H31.25V62.5H62.5V31.25ZM59.2188 34.5312H34.6875V59.5312H59.2188V34.5312Z","fill":"#114E8B","key":2}),React.createElement("rect",{"x":"12.5","y":"12.5","width":"31.25","height":"31.25","rx":"2","fill":"#428FDA","key":3})]);
}

ComponentsIcon.defaultProps = {"width":"75","height":"75","viewBox":"0 0 75 75","fill":"none"};

module.exports = ComponentsIcon;

ComponentsIcon.default = ComponentsIcon;
